// I18N_START
const TRANSLATIONS = {
  en: {
    best: "Best: {n}",
    combo: "🔥 Combo ×{n}",
    game_over: "Game Over",
    new_record: "New Record!",
    score: "Score: {n}",
    tap_to_play: "Tap to play again",
    tap_to_start: "Tap to start",
    resume: "Resume",
    restart_game: "Restart",
    to_hub: "Home",
    hook_bb_fivelines: "Clear 5 lines in one move!",
    hook_bb_fourlines: "Blast 4 lines at once",
    hook_bb_midgame: "Keep the combo going",
    hook_play: "Play",
    cta_win_title: "Boom! 🎉",
    cta_install: "Add to home screen",
    cta_again: "Play again",
  },
  hi: {
    best: "सर्वश्रेष्ठ: {n}",
    combo: "🔥 कॉम्बो ×{n}",
    game_over: "खेल समाप्त",
    new_record: "नया रिकॉर्ड!",
    score: "स्कोर: {n}",
    tap_to_play: "फिर से खेलने के लिए टैप करें",
    tap_to_start: "शुरू करने के लिए टैप करें",
    resume: "जारी रखें",
    restart_game: "फिर से",
    to_hub: "मुख्य",
    hook_bb_fivelines: "एक चाल में 5 लाइनें साफ़!",
    hook_bb_fourlines: "एक साथ 4 लाइनें उड़ाएँ",
    hook_bb_midgame: "कॉम्बो जारी रखें",
    hook_play: "खेलें",
    cta_win_title: "बूम! 🎉",
    cta_install: "होम स्क्रीन पर जोड़ें",
    cta_again: "फिर से खेलें",
  },
  ru: {
    best: "Лучший: {n}",
    combo: "🔥 Комбо ×{n}",
    game_over: "Игра окончена",
    new_record: "Новый рекорд!",
    score: "Очки: {n}",
    tap_to_play: "Нажмите чтобы сыграть снова",
    tap_to_start: "Нажмите чтобы начать",
    resume: "Продолжить",
    restart_game: "Заново",
    to_hub: "В хаб",
    hook_bb_fivelines: "5 линий одним ходом!",
    hook_bb_fourlines: "Взорви 4 линии сразу",
    hook_bb_midgame: "Держи комбо",
    hook_play: "Играть",
    cta_win_title: "Бум! 🎉",
    cta_install: "Добавить на экран",
    cta_again: "Ещё разок",
  },
} as const;
// I18N_END

type Lang = keyof typeof TRANSLATIONS;
type Key  = keyof typeof TRANSLATIONS['ru'];
type Params = Record<string, string | number>;

const _lang = (localStorage.getItem('lang') ?? navigator.language.slice(0, 2)) as Lang;
const _L    = TRANSLATIONS[_lang in TRANSLATIONS ? _lang : 'ru'];

export function t(key: Key, params?: Params): string {
  let s: string = _L[key] ?? TRANSLATIONS['ru'][key];
  if (params) for (const k in params) s = s.replace(`{${k}}`, String(params[k]));
  return s;
}
